module.exports = __webpack_public_path__ + "static/media/planB.6c94e977.jpg";